module.exports = __webpack_public_path__ + "static/media/card3.c7d49b78.png";